module.exports = __webpack_public_path__ + "static/media/main.87961c71.png";